import React, { useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';

import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../components/common/FilterBy';
import { SearchBar } from '../../../components/common/SearchBar';
import { CustomPagination, TableCustom } from '../../../components/common';
import useDebounce from '../../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
} from '../../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../../components/common/Modal';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import CategoryList from './CategoryList';

const freq_in_month: any = {
  1: '1 Month',
  3: '3 Month',
  6: '6 Month',
  12: '12 Month',
};

const tableHeaderObj = [
  [
    { text: 'S.No.', rowspan: 1, colspan: 1 },
    { text: 'Equipment No.', rowspan: 1, colspan: 1 },
    { text: 'Equipment Name', rowspan: 1, colspan: 1 },
    { text: 'FREQUENCY', rowspan: 1, colspan: 1 },
    // { text: 'UNIQUE I.D NO.', rowspan: 1, colspan: 1 },
    // { text: 'CALIBRATION FREQ', rowspan: 1, colspan: 1 },
    // { text: 'SIZE', rowspan: 1, colspan: 1 },
    // { text: 'LEAST COUNT', rowspan: 1, colspan: 1 },
    { text: 'Capacity	', rowspan: 1, colspan: 1 },
    { text: 'Make', rowspan: 1, colspan: 1 },
    { text: 'Installation Year', rowspan: 1, colspan: 1 },
    { text: 'Location', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [
  { value: 'createdAt', name: 'A-Z' },
  { value: 'customer_name', name: 'Customer Name' },
];

const List = () => {
  const [data, setData] = useState<any[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [listId, setListId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const [categoryModal, setCategoryModal] = useState(false);
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?'
  );

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/masterlistofAppearance/?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.result);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const handleDelete = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/masterlistofAppearance/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal, filter]);

  return (
    <>
      <ChildHeader text="MASTER LIST OF Utilities">
        <AddButton onClick={() => setIsModal(true)} label="New UTILITY" />
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search" />
        <FilterBy options={filterOptions} />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: any, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>

                  <TableCell align="center">{item?.equipment_no}</TableCell>
                  <TableCell align="center">{item?.equipment_name}</TableCell>
                  <TableCell align="center">{item?.frequency}</TableCell>
                  <TableCell align="center">{item?.capacity}</TableCell>
                  <TableCell align="center">{item?.make}</TableCell>
                  <TableCell align="center">
                    {new Date(item?.installation_year).getFullYear()}
                  </TableCell>
                  <TableCell align="center">
                    {item?.department_id?.department_name}
                  </TableCell>
                  {/* <TableCell align="center">{item.id_no}</TableCell>
                  <TableCell align="center">
                    {freq_in_month[item?.frequency_cycle]}
                  </TableCell>
                  <TableCell align="center">{item.range}</TableCell>
                  <TableCell align="center">{item.least_count}</TableCell>
                   */}
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setListId(item?._id || '');
                          setIsModal(true);
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          handleDelete(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setListId(null);
          setIsModal(false);
        }}
        title={'CREATE NEW Appearance'}
      >
        <Create id={listId} setIsModal={setIsModal} setListId={setListId} />
      </ModalCustom>
      <ModalCustom
        openModal={categoryModal}
        closeModal={() => {
          setCategoryModal(false);
        }}
        title="CATEGORY LIST"
      >
        <CategoryList />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
